<!--  安装订单确认安装流程  -->
<template>
    <div>
        <div>
            <van-sticky>
                <div style="padding: 10px 0px 0px 0px">
                    <van-icon name="arrow-left" size="20px" @click="onback"/>
                </div>
            </van-sticky>
        </div>
        <div style="padding: 10px;">
            <Row>
                <label>车牌号：{{install.vehicleInfo != null ? install.vehicleInfo.registrationNum :
                    install.tempVehicleInfo.registrationNum}}</label>
                <van-button size="mini" type="info" :disabled="discern" style="margin-right: 5px;float: right;"
                            @click="onAnalyzeVehicleLicensePicture(installOrderId)">识别行驶证
                </van-button>
            </Row>
            <Row>
                <label>车架号：{{install.vehicleInfo != null ? install.vehicleInfo.vin :
                    install.tempVehicleInfo.vin}}</label>
            </Row>
            <Row>
                <label style="color: #fc0000;">备注：{{install.remark != null ? install.remark :
                    '无'}}</label>
            </Row>
        </div>
        <div>
            <!--  异步更新页面  -->
            <!--            <van-tabs v-model="active" @click="onClick">-->
            <van-tabs v-model="active">
                <van-tab title="配机">
                    <div v-if="positioningDeviceInfos.length == 0">
                        <Card style="width:100%">
                            <Row>
                                <label>未绑定设备</label>
                            </Row>
                        </Card>
                    </div>
                    <div v-for="index in positioningDeviceInfos">
                        <Card style="width:100%">
                            <Row>
                                <label>主机号：{{index.terminalNum}}</label>
                            </Row>
                            <Row>
                                <label>设备型号：{{index.positioningDeviceModel.name}}</label>
                                <!--                            </Row>-->
                                <!--                            <Row>-->
                                <Button style="position:absolute;right: 10px;" type="error" size="small"
                                        @click="onunBindPositioningDeviceInfos(index.id)">解绑
                                </Button>
                            </Row>
                        </Card>
                    </div>

                    <div style="position: fixed;bottom: 50px;width: 100%;padding: 5px;">
                        <Form autoComplete="on" class="card-box login-form">
                            <Row>
                                <Form-item label="设备主机号">
                                    <Select style="width: 48%;padding-right: 5px;"
                                            v-model="selectPositioningDeviceInfos"
                                            multiple
                                            filterable
                                            remote
                                            :remote-method="searchPositioningDeviceInfo"
                                            :loading="searchPositioningDeviceInfoLoading">
                                        <Option v-for="(option, index) in searchPositioningDeviceInfoList"
                                                :value="option.id" :key="option.id">{{option.terminalNum}}
                                        </Option>
                                    </Select>
                                    <Button type="primary" @click="onBindPositioningDeviceInfos" style="margin-right: 5px;">绑定</Button>
                                    <Button type="primary" @click="addPositioningDeviceInfoModal = true">添加</Button>
                                </Form-item>
                            </Row>
                        </Form>
                    </div>
                    <add-positioning-device-info-modal v-model="addPositioningDeviceInfoModal"></add-positioning-device-info-modal>
                    <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                        下一步
                    </Button>
                </van-tab>
                <van-tab title="配件">

                    <div v-if="positioningDeviceFittingsInfos.length == 0">
                        <Card style="width:100%">
                            <Row>
                                <label>未绑定设备配件</label>
                            </Row>
                        </Card>
                    </div>
                    <div v-for="index in positioningDeviceFittingsInfos">
                        <Card style="width:100%">
                            <Row>
                                <label>设备型号：{{index.positioningDeviceModel.name}}</label>
                            </Row>
                            <!--                            <Row>-->
                            <!--                                <Button style="position:absolute;right: 20px;bottom: 00px;" type="error" size="small"-->
                            <!--                                        @click="onunBindPositioningDeviceInfos(index.id)">解绑-->
                            <!--                                </Button>-->
                            <!--                            </Row>-->
                            <van-collapse v-model="activeNames">
                                <van-collapse-item name="1">
                                    <Row>
                                        <Form ref="loginForm" :model="positioningDeviceFittingsInfos">
                                            <!--                                <FormItem prop="positioningdevicemodel">-->
                                            <!--                                    <label>定位设备类型：</label>-->
                                            <!--                                    <Select placeholder="请选择设备类型" style="display: inline-block; width: 130px;" @on-change="selectPositioningDeviceInfo" :disabled="!modify"-->
                                            <!--                                            v-model="index.positioningDeviceModelId"  size="small"-->
                                            <!--                                    >-->
                                            <!--                                        <Option v-for="(option, index) in positioningDeviceType" :value="option.id" :key="option.id">{{option.name}}</Option>-->
                                            <!--                                    </Select>-->
                                            <!--                                    <Checkbox v-model="index.lcdproperties" :disabled="!modify" style="padding-left: 5px">LCD属性</Checkbox>-->
                                            <!--                                </FormItem>-->
                                            <FormItem prop="starLightAlarm">
                                                <Checkbox v-model="index.starLightAlarm" :disabled="!modify">声光报警：
                                                </Checkbox>
                                                <Select placeholder="请选择声光报警类型"
                                                        style="display: inline-block; width: 130px;"
                                                        :disabled="!index.starLightAlarm || !modify"
                                                        v-model="index.starLightAlarmid" size="small"
                                                >
                                                    <Option v-for="(option, index) in starLightAlarmType"
                                                            :value="option.id" :key="option.id">{{option.name}}
                                                    </Option>
                                                </Select>
                                            </FormItem>
                                            <FormItem prop="interphone">
                                                <Checkbox v-model="index.interphone" :disabled="!modify">对讲机：</Checkbox>
                                                <Select placeholder="请选择对讲机类型"
                                                        style="display: inline-block; width: 130px;"
                                                        :disabled="!index.interphone || !modify"
                                                        v-model="index.interphoneid" size="small"
                                                >
                                                    <Option v-for="(option, index) in interphoneType" :value="option.id"
                                                            :key="option.id">{{option.name}}
                                                    </Option>
                                                </Select>
                                            </FormItem>
                                            <FormItem prop="trumpet">
                                                <Checkbox v-model="index.trumpet" :disabled="!modify">喇叭：</Checkbox>
                                                <Select placeholder="请选择喇叭类型"
                                                        style="display: inline-block; width: 130px;"
                                                        :disabled="!index.trumpet || !modify"
                                                        v-model="index.trumpetid" size="small"
                                                >
                                                    <Option v-for="(option, index) in trumpetType" :value="option.id"
                                                            :key="option.id">{{option.name}}
                                                    </Option>
                                                </Select>
                                            </FormItem>
                                            <FormItem prop="trumpet">
                                                <Checkbox v-model="index.viewingScreen" :disabled="!modify">显示屏：
                                                </Checkbox>
                                                <Select placeholder="请选择显示屏类型"
                                                        style="display: inline-block; width: 130px;"
                                                        :disabled="!index.viewingScreen || !modify"
                                                        v-model="index.viewingScreenid" size="small"
                                                >
                                                    <Option v-for="(option, index) in viewingScreenType"
                                                            :value="option.id" :key="option.id">{{option.name}}
                                                    </Option>
                                                </Select>
                                            </FormItem>
                                            <FormItem prop="hardDisk">
                                                <Checkbox v-model="index.hardDisk" :disabled="!modify">硬盘：</Checkbox>
                                                <Select placeholder="请选择硬盘类型"
                                                        style="display: inline-block; width: 130px;"
                                                        :disabled="!index.hardDisk || !modify"
                                                        v-model="index.hardDiskid" size="small"
                                                >
                                                    <Option v-for="(option, index) in hardDiskType" :value="option.id"
                                                            :key="option.id">{{option.name}}
                                                    </Option>
                                                </Select>
                                            </FormItem>
                                            <FormItem prop="extensionCord">
                                                <Checkbox v-model="index.extensionCord" :disabled="!modify">延长线：
                                                </Checkbox>
                                                <div style="display: inline-table;">
                                                    <Select placeholder="1米延长线类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.extensionCord || !modify"
                                                            v-model="index.extensionCordOneid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in extensionCordType"
                                                                :value="option.id" :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.extensionCordOneNum" :min="0"
                                                                 :disabled="!index.extensionCord  || !modify"
                                                                 size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                    <br>
                                                    <Select placeholder="5米长线类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.extensionCord || !modify"
                                                            v-model="index.extensionCordFiveid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in extensionCordType"
                                                                :value="option.id" :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.extensionCordFiveNum" :min="0"
                                                                 :disabled="!index.extensionCord || !modify"
                                                                 size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                    <br>
                                                    <Select placeholder="15米延长线类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.extensionCord || !modify"
                                                            v-model="index.extensionCordFifteenid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in extensionCordType"
                                                                :value="option.id" :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.extensionCordFifteenNum" :min="0"
                                                                 :disabled="!index.extensionCord || !modify"
                                                                 size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                </div>
                                            </FormItem>
                                            <!--          </div>-->
                                            <!--          <div slot="right" class="demo-split-pane">-->
                                            <FormItem prop="trumpet">
                                                <InputNumber v-model="index.cameraMatchADAS" :min="0"
                                                             :disabled="!modify" size="small"
                                                             style="margin-left: 5px;width: 45px"></InputNumber>
                                                <InputNumber v-model="index.cameraMatch" :min="0" :disabled="!modify"
                                                             size="small"
                                                             style="margin-left: 5px;width: 45px"></InputNumber>
                                                <InputNumber v-model="index.cameraMatchNetwork" :min="0"
                                                             :disabled="!modify" size="small"
                                                             style="margin-left: 5px;width: 45px"></InputNumber>
                                            </FormItem>
                                            <FormItem prop="Match">
                                                <Checkbox v-model="index.camera" :disabled="!modify">摄像头：</Checkbox>
                                                <div style="display: inline-table;">
                                                    <Select placeholder="摄像头类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.camera || !modify"
                                                            v-model="index.cameraOneid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in cameraType" :value="option.id"
                                                                :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.cameraOneNum" :min="0"
                                                                 :disabled="!index.camera || !modify" size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                    <br>
                                                    <Select placeholder="摄像头类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.camera || !modify"
                                                            v-model="index.cameraTwoid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in cameraType" :value="option.id"
                                                                :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.cameraTwoNum" :min="0"
                                                                 :disabled="!index.camera || !modify" size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                    <br>
                                                    <Select placeholder="摄像头类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.camera || !modify"
                                                            v-model="index.cameraThreeid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in cameraType" :value="option.id"
                                                                :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.cameraThreeNum" :min="0"
                                                                 :disabled="!index.camera || !modify" size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                    <br>
                                                    <Select placeholder="摄像头类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.camera || !modify"
                                                            v-model="index.cameraFourid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in cameraType" :value="option.id"
                                                                :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.cameraFourNum" :min="0"
                                                                 :disabled="!index.camera || !modify" size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                    <br>
                                                    <Select placeholder="摄像头类型"
                                                            style="display: inline-block; width: 130px;"
                                                            :disabled="!index.camera || !modify"
                                                            v-model="index.cameraFiveid" size="small"
                                                    >
                                                        <Option v-for="(option, index) in cameraType" :value="option.id"
                                                                :key="option.id">{{option.name}}
                                                        </Option>
                                                    </Select>
                                                    <InputNumber v-model="index.cameraFiveNum" :min="0"
                                                                 :disabled="!index.camera || !modify" size="small"
                                                                 style="margin-left: 5px;width: 45px"></InputNumber>
                                                </div>
                                            </FormItem>
                                        </Form>
                                    </Row>
                                </van-collapse-item>
                            </van-collapse>

                        </Card>
                    </div>

                    <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                        上一步
                    </Button>
                    <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                        下一步
                    </Button>
                </van-tab>
                <van-tab title="勾选通道">
                    <div v-for="(item,index) in positioningDeviceInfos">
                        <Card style="width:100%" v-if="item.positioningDeviceModel.adas">
                            <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
                                <label>设备型号：{{item.positioningDeviceModel.name}}</label>
                                <!--                                <Checkbox style="padding-left: 30px;"-->
                                <!--                                        :indeterminate="indeterminate"-->
                                <!--                                        :value="checkAll"-->
                                <!--                                        @click.prevent.native="handleCheckAll">全选-->
                                <!--                                </Checkbox>-->

                                <Button style="position:absolute;right: 20px;" type="error" size="small"
                                        @click="onPositioningDeviceInfoAisle(item)">保存
                                </Button>
                            </div>

                            <div>
                                <CheckboxGroup v-model="checkAllGroup[index]">
                                    <Checkbox label="1" class="Checkbox"
                                              v-model="item.aisleOne"></Checkbox>
                                    <Checkbox label="2" class="Checkbox"
                                              v-model="item.aisleTwo"></Checkbox>
                                    <Checkbox label="3" class="Checkbox"
                                              v-model="item.aisleThree"></Checkbox>
                                    <Checkbox label="4" class="Checkbox"
                                              v-model="item.aisleFour"></Checkbox>
                                    <Checkbox label="5" class="Checkbox"
                                              v-model="item.aisleFive"></Checkbox>
                                    <Checkbox label="6" class="Checkbox"
                                              v-model="item.aisleSix"></Checkbox>
                                    <Checkbox label="7" class="Checkbox"
                                              v-model="item.aisleSeven"></Checkbox>
                                    <Checkbox label="8" class="Checkbox"
                                              v-model="item.aisleEight"></Checkbox>
                                    <Checkbox label="9" class="Checkbox"
                                              v-model="item.aisleNine"></Checkbox>
                                    <Checkbox label="10" class="Checkbox"
                                              v-model="item.aisleTen"></Checkbox>
                                </CheckboxGroup>
                            </div>
                        </Card>
                    </div>
                    <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                        上一步
                    </Button>
                    <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                        下一步
                    </Button>
                </van-tab>
                <van-tab title="资料图片">

                    <uploader-install-order-vehicle-material-image
                            v-model="UploaderInstallOrderVehicleMaterialImageModal"
                            :initValue="UploaderInstallOrderVehicleMaterialImageId"></uploader-install-order-vehicle-material-image>

                    <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                        上一步
                    </Button>
                    <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                        下一步
                    </Button>
                </van-tab>
                <van-tab title="安装图片">

                    <uploader-install-order-install-image v-model="UploaderInstallOrderInstallImageModal"
                                                          :initValue="UploaderInstallOrderInstallImageId"></uploader-install-order-install-image>

<!--                    <div class="weui-uploader__input-box">-->
<!--                        <input id="uploaderInput" ref="uploaderInput" class="weui-uploader__input" type="file" accept="image/*" capture="camera" multiple="" @change="inputonchange"/>-->
<!--                    </div>-->
                    <div class="weui-uploader__input-box">
                        <input ref="uploaderInput" class="weui-uploader__input" type="file" accept="image/*" capture="camera" @change="inputonchange(1)"/>
                    </div>

                    <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                        上一步
                    </Button>
                    <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                        下一步
                    </Button>
                </van-tab>
                <van-tab title="设备状态">

                    <jt808-devices-for-terminalnum-modal v-model="jt808DevicesForTerminalnumModal"
                                                         :initValue="jt808DevicesForTerminalnumId"></jt808-devices-for-terminalnum-modal>

                    <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                        上一步
                    </Button>
                    <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                        下一步
                    </Button>
                </van-tab>
                <van-tab title="确认">

                    <div style="padding-bottom: 50px;">
                        <!--  车辆识别码修改  -->
                        <Card style="width:100%">
                            <van-cell-group>
                                <van-field
                                        v-model="identificationCode"
                                        center
                                        clearable
                                        label="车辆识别码"
                                        placeholder="请输入车辆识别码"
                                        border="false"
                                        use-button-slot
                                >
                                    <van-button slot="button" size="small" type="primary" @click="onIdentificationCode">
                                        保存
                                    </van-button>
                                </van-field>
                            </van-cell-group>
                        </Card>

                        <!--  订单是否拆机，勾选设备选项  -->
                        <!--                        <Card style="width:100%">-->
                        <!--                            <div v-for="(item,index) in devicescontent">-->
                        <!--                                <van-checkbox-group v-model="radio" :max="1" @change="onCheckbox">-->
                        <!--                                    <Card style="width:100%">-->
                        <!--                                        <Row>-->
                        <!--                                            <label>主机号：{{item.terminalNum}}</label>-->
                        <!--                                        </Row>-->
                        <!--                                        <Row>-->
                        <!--                                            <label>设备型号：{{item.positioningDeviceModel.name}}</label>-->
                        <!--                                        </Row>-->
                        <!--                                        <van-checkbox :name=item>复选框{{index}}</van-checkbox>-->
                        <!--                                    </Card>-->
                        <!--                                </van-checkbox-group>-->
                        <!--                            </div>-->
                        <!--                        </Card>-->

                    </div>

                    <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                        上一步
                    </Button>
                    <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onSueeess(active)">
                        确认
                    </Button>
                </van-tab>
            </van-tabs>

        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import axios from 'axios'
    import weui from 'weui.js'

    import AddPositioningDeviceInfoModal from '@/views/im/components/add-positioning-device-info-modal'
    import UploaderInstallOrderVehicleMaterialImage
        from '@/views/om/components/Uploader-install-order-vehicle-material-image'
    import UploaderInstallOrderInstallImage from '@/views/om/components/uploader-install-order-install-image'
    import Jt808DevicesForTerminalnumModal from '@/views/ddm/components/jt808-devices-for-terminalnum-modal'

    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast, Tab, Tabs
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast).use(Tab).use(Tabs);

    export default {
        name: "installer-install-order-confirm",
        components: {
            AddPositioningDeviceInfoModal,
            UploaderInstallOrderVehicleMaterialImage,
            UploaderInstallOrderInstallImage,
            Jt808DevicesForTerminalnumModal,
        },
        data() {
            return {
                install: null,//订单
                installOrderId: null,//订单ID
                active: null,//流程页下标

                positioningDeviceInfos: [],//已绑定的设备
                searchPositioningDeviceInfoList: [],//查询设备
                searchPositioningDeviceInfoLoading: false,
                selectPositioningDeviceInfos: [],//查询设备后选择设备

                activeNames: [],
                modify: true,
                positioningDeviceFittingsInfos: [],//已绑定的设备配件
                // 设备类型
                positioningDeviceType: [],
                // 声光报警类型
                starLightAlarmType: [],
                // 对讲机类型
                interphoneType: [],
                // 喇叭类型
                trumpetType: [],
                // 显示屏类型
                viewingScreenType: [],
                // 硬盘类型
                hardDiskType: [],
                // 延长线类型
                extensionCordType: [],
                // 摄像头类型
                cameraType: [],

                //勾选通道
                checkAllGroup: [
                    [], [], [], [], []
                ],

                /**
                 * 添加设备信息
                 */
                addPositioningDeviceInfoModal:false,

                /**
                 * 车辆资料图片
                 */
                UploaderInstallOrderVehicleMaterialImageModal: false,
                UploaderInstallOrderVehicleMaterialImageId: null,

                /**
                 * 车辆安装图片
                 */
                UploaderInstallOrderInstallImageModal: false,
                UploaderInstallOrderInstallImageId: null,

                identificationCode: null,//车辆识别码

                /**
                 * jt808,实时状态
                 */
                jt808DevicesForTerminalnumModal: false,
                jt808DevicesForTerminalnumId: [],


                /**
                 * 是否拆除设备
                 * 显示设备列表
                 */
                devicescontent: [],
                radio: [],

                discern: false,
            }
        },
        methods: {
            // <!-- icon返回路劲 -->
            onback() {
                this.$router.push({
                    name: 'installerinstallorder'
                })
            },
            // onClick(name, title) {
            //     Toast(name);
            // },
            //识别行车证
            onAnalyzeVehicleLicensePicture(e) {
                this.discern = true
                //车辆信息
                store.dispatch('InstallOrderServ_GetDetail', {
                    params: {id: e},
                    urlparams: null
                }).then((res) => {


                    if (res.data.vehicleInfoId) {
                        //已完成的订单
                        //  识别行驶证
                        store.dispatch('VehicleInfoServ_AnalyzeVehicleLicensePicture', {
                            params: {id: res.data.vehicleInfoId},
                            urlparams: null
                        }).then((res) => {
                            console.log(res)
                            this.discern = false
                            this.onFind()
                        }).catch((err) => {
                            Toast(err)
                            this.discern = false
                        })
                    } else {
                        //未完成的订单

                        let installOrder = store.getters.get_InstallOrder_GetDetailResult
                        this.installOrder = installOrder
                        let vehicleInfo = this.installOrder.tempVehicleInfo
                        if (vehicleInfo.vehicleLicensePicture) {
                            //  识别行驶证
                            store.dispatch('InstallOrderServ_AnalyzeVehicleLicensePicture', {
                                params: {id: e},
                                urlparams: null
                            }).then((res) => {
                                console.log(res)
                                this.discern = false
                                this.onFind()
                            }).catch((err) => {
                                Toast(err + '请重新上传');
                                // this.$Message.error(err + '请重新上传');
                                this.discern = false
                            })
                        } else {
                            Toast('未上传行驶证');
                            // this.$Message.warning('未上传行驶证');
                            this.discern = false
                        }
                    }
                }).catch((err) => {
                    console.log(err)
                    this.discern = false
                })
            },
            /**
             * 流程上一步
             */
            onLastPage(page) {
                console.log(page)
                this.active = page - 1;
            },
            /**
             * 流程下一步
             */
            onNextPage(page) {
                console.log(page)
                if (page == 1) {
                    this.positioningDeviceFittingsInfos.forEach(item => {
                        store.dispatch('PositioningDeviceFittingsServ_ModifyObj', {
                            params: item
                        }).then(() => {
                            this.$Message.success('配件保存成功')
                            this.updateTable()
                            this.$emit('on-success')
                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail')
                        })
                    })
                }
                if (page == 2) {
                    this.positioningDeviceInfos.forEach(item => {
                        if (item.setupDatetime) {
                            item.setupDatetime = new Date(item.setupDatetime)
                        }
                        store.dispatch('PositioningDeviceInfoServ_ModifyObj', {
                            params: item
                        }).then(() => {
                            this.$Message.success('通道保存成功')
                            this.updateTable()
                            this.$emit('on-success')
                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail')
                        })
                    })
                }
                this.active = page + 1;
            },
            /**
             * 安装确认
             */
            onSueeess() {
                /**
                 * 保存车辆识别码
                 */
                if (this.identificationCode != null && this.identificationCode != '') {
                    if (this.install.vehicleInfoId != null) {
                        this.install.vehicleInfo.identificationCode = this.identificationCode
                        store.dispatch('VehicleInfoServ_ModifyObj', {params: this.install.vehicleInfo}).then(() => {
                            this.$Message.success('修改车辆识别码成功')
                            this.updateTable()
                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail');
                        })
                    } else {
                        this.install.tempVehicleInfo.identificationCode = this.identificationCode
                        store.dispatch('InstallOrderServ_ModifyObj', {params: this.install}).then(() => {
                            this.$Message.success('修改车辆识别码')
                            this.updateTable()
                            this.onback()
                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail');
                        })
                    }
                }else {
                    this.updateTable()
                    this.onback()
                }

                // if (this.install.installed) {
                //     this.onback()
                // }else {
                //     this.$Modal.confirm({
                //         title: '确认安装',
                //         content: '<p>确认安装</p>',
                //         onOk: () => {
                //             if (this.install.positioningDeviceInfosCount != null && this.install.positioningDeviceInfosCount > 0) {
                //                 //确认安装完成
                //                 store.dispatch('InstallOrderServ_ConfirmInstalled', {
                //                     params: {
                //                         id: this.install.id,
                //                         setupDatetime: new Date()
                //                     },
                //                     urlparams: null
                //                 }).then((res) => {
                //                     console.log(res)
                //                     Toast('确认成功')
                //                     this.onback()
                //                 }).catch((err) => {
                //                     console.log(err)
                //                     Toast('确认失败' + err)
                //                 })
                //             } else {
                //                 Toast('未绑定设备');
                //             }
                //         },
                //         onCancel: () => {
                //             this.updateTable()
                //         }
                //     })
                // }

            },
            /**
             * 模糊查询设备
             */
            searchPositioningDeviceInfo(input) {
                console.log(input)
                this.searchPositioningDeviceInfoLoading = true
                if (!input || input.length <= 0) {
                    this.searchPositioningDeviceInfoList = []
                    this.searchPositioningDeviceInfoLoading = false
                } else {
                    store.dispatch('PositioningDeviceInfoServ_SearchByName', {
                        params: {name: input},
                        urlparams: null
                    }).then(() => {
                        this.searchPositioningDeviceInfoList = store.getters.get_PositioningDeviceInfo_SearchByNameResult ? store.getters.get_PositioningDeviceInfo_SearchByNameResult : []
                        this.searchPositioningDeviceInfoLoading = false
                    }).catch(err => {
                        this.searchPositioningDeviceInfoLoading = false
                    })
                }
            },
            /**
             * 解绑订单设备
             */
            onunBindPositioningDeviceInfos(positioningDeviceInfoId) {
                this.$Modal.confirm({
                    title: '确认解绑设备',
                    content: '<p>确认解绑设备</p>',
                    onOk: () => {
                        store.dispatch('InstallOrderServ_UnBindPositioningDeviceInfos', {
                            params: {id: this.installOrderId, positioningDeviceInfoIds: [positioningDeviceInfoId]}
                        }).then(() => {
                            this.$Message.success('解绑成功')
                            this.updateTable()
                            this.$emit('on-success')
                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail')
                        })
                    },
                    onCancel: () => {

                    }
                })
            },
            /**
             * 绑定订单设备
             */
            onBindPositioningDeviceInfos() {
                this.$Modal.confirm({
                    title: '确认绑定设备',
                    content: '<p>确认绑定设备</p>',
                    onOk: () => {
                        store.dispatch('InstallOrderServ_BindPositioningDeviceInfos', {
                            params: {
                                id: this.installOrderId,
                                positioningDeviceInfoIds: this.selectPositioningDeviceInfos
                            }
                        }).then(() => {
                            this.$Message.success('修改成功')
                            this.updateTable()
                            this.$emit('on-success')
                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail')
                        })
                    },
                    onCancel: () => {

                    }
                })
            },
            onPositioningDeviceInfoAisle(index) {

                this.$Modal.confirm({
                    title: '确认修改定位设备通道',
                    content: '<p>确认修改定位设备信息</p>',
                    onOk: () => {
                        if (index.setupDatetime) {
                            index.setupDatetime = new Date(index.setupDatetime)
                        }
                        store.dispatch('PositioningDeviceInfoServ_ModifyObj', {
                            params: index
                        }).then(() => {
                            this.$Message.success('修改成功')
                            this.updateTable()
                            this.$emit('on-success')
                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail')
                        })
                    },
                    onCancel: () => {
                        this.updateTable()
                    }
                })
            },

            onIdentificationCode() {
                this.$Modal.confirm({
                    title: '确认修改车辆识别码',
                    content: '<p>确认修改车辆识别码</p>',
                    onOk: () => {
                        if (this.install.vehicleInfoId != null) {
                            this.install.vehicleInfo.identificationCode = this.identificationCode
                            store.dispatch('VehicleInfoServ_ModifyObj', {params: this.install.vehicleInfo}).then(() => {
                                this.$Message.success('修改车辆识别码成功')
                                this.updateTable()
                            }).catch(err => {
                                this.$Message.error(err)
                                this.$emit('on-fail');
                            })
                        } else {
                            this.install.tempVehicleInfo.identificationCode = this.identificationCode
                            store.dispatch('InstallOrderServ_ModifyObj', {params: this.install}).then(() => {
                                this.$Message.success('修改车辆识别码')
                                this.updateTable()
                            }).catch(err => {
                                this.$Message.error(err)
                                this.$emit('on-fail');
                            })
                        }
                    },
                    onCancel: () => {
                        this.updateTable()
                    }
                })
            },
            updateTable() {
                /**
                 * 查询该订单绑定的设备
                 */
                this.searchPositioningDeviceInfoList = []
                this.selectPositioningDeviceInfos = []
                let queryParams = []
                let sortParam = null
                queryParams.push(genQueryParam('installOrderId', 'EQ', this.installOrderId))
                store.dispatch('PositioningDeviceInfoServ_GetAll', {
                    params: null,
                    urlparams: {
                        q: queryParams,
                        keyword: null,
                        sort: sortParam
                    }
                }).then(() => {
                    if (store.getters.get_PositioningDeviceInfo_GetAllResult) {
                        this.positioningDeviceInfos = store.getters.get_PositioningDeviceInfo_GetAllResult
                        store.getters.get_PositioningDeviceInfo_GetAllResult.forEach((item, index) => {
                            if (item.aisleOne) {
                                this.checkAllGroup[index].push('1')
                            } else {
                                item.aisleOne = false
                            }
                            if (item.aisleTwo) {
                                this.checkAllGroup[index].push('2')
                            } else {
                                item.aisleTwo = false
                            }
                            if (item.aisleThree) {
                                this.checkAllGroup[index].push('3')
                            } else {
                                item.aisleThree = false
                            }
                            if (item.aisleFour) {
                                this.checkAllGroup[index].push('4')
                            } else {
                                item.aisleFour = false
                            }
                            if (item.aisleFive) {
                                this.checkAllGroup[index].push('5')
                            } else {
                                item.aisleFive = false
                            }
                            if (item.aisleSix) {
                                this.checkAllGroup[index].push('6')
                            } else {
                                item.aisleSix = false
                            }
                            if (item.aisleSeven) {
                                this.checkAllGroup[index].push('7')
                            } else {
                                item.aisleSeven = false
                            }
                            if (item.aisleEight) {
                                this.checkAllGroup[index].push('8')
                            } else {
                                item.aisleEight = false
                            }
                            if (item.aisleNine) {
                                this.checkAllGroup[index].push('9')
                            } else {
                                item.aisleNine = false
                            }
                            if (item.aisleTen) {
                                this.checkAllGroup[index].push('10')
                            } else {
                                item.aisleTen = false
                            }

                            /**
                             * 按设备信息查询jt808状态
                             */
                            this.jt808DevicesForTerminalnumId = []
                            this.jt808DevicesForTerminalnumId.push(item)
                        })
                    }
                }).catch(err => {
                    this.$Message.error(err)
                })

                /**
                 * 查询所有配件
                 */
                store.dispatch('PositioningDeviceFittingsTypeServ_GetAll', {
                    params: {},
                    urlparams: null
                }).then(() => {
                    if (store.getters.get_PositioningDeviceFittingsType_GetAllResult) {
                        store.getters.get_PositioningDeviceFittingsType_GetAllResult.forEach(item => {
                            // 摄像头
                            if (item.type == 0) {
                                this.cameraType.push(item)
                            }
                            if (item.type == 1) {
                                this.viewingScreenType.push(item)
                            }
                            if (item.type == 2) {
                                this.extensionCordType.push(item)
                            }
                            if (item.type == 3) {
                                this.hardDiskType.push(item)
                            }
                            if (item.type == 4) {
                                this.starLightAlarmType.push(item)
                            }
                            if (item.type == 5) {
                                this.interphoneType.push(item)
                            }
                            if (item.type == 6) {
                                this.trumpetType.push(item)
                            }
                        })
                    }
                }).catch(err => {
                    console.log(err)
                })

                /**
                 * 查询该订单绑定的设备配件
                 */
                let queryParams1 = []
                let sortParam1 = null
                queryParams1.push(genQueryParam('installOrderId', 'EQ', this.installOrderId))
                store.dispatch('PositioningDeviceFittingsServ_GetAll', {
                    params: null,
                    urlparams: {
                        q: queryParams1,
                        keyword: null,
                        sort: sortParam1
                    }
                }).then(() => {
                    if (store.getters.get_PositioningDeviceFittings_GetAllResult) {
                        this.positioningDeviceFittingsInfos = store.getters.get_PositioningDeviceFittings_GetAllResult
                    }
                }).catch(err => {
                    this.$Message.error(err)
                })

                /**
                 * 查询车辆识别码
                 */
                if (this.install.vehicleInfoId != null) {
                    this.identificationCode = this.install.vehicleInfo.identificationCode
                } else {
                    this.identificationCode = this.install.tempVehicleInfo.identificationCode
                }
            },
            /**
             * 是否拆除设备
             * 拆除那一台设备
             */
            onCheckbox() {
                console.log(this.radio)
                if (this.radio.length == 0) {
                    /**
                     * 不拆除设备
                     */
                    this.install.positioningDeviceId = null
                    this.install.positioningDevice = null
                    store.dispatch('InstallOrderServ_ModifyInstallOrderBase', {params: this.install})
                        .then(() => {
                            this.$Message.success('确认修改安装订单')
                            this.updateTable()
                        }).catch(err => {
                        this.$Message.error('错误' + err)
                        this.updateTable()
                    })
                } else {
                    /**
                     * 要拆除设备
                     * this.radio[0]
                     */
                    this.install.positioningDeviceId = this.radio[0].id
                    this.install.positioningDevice = this.radio[0]
                    store.dispatch('InstallOrderServ_ModifyInstallOrderBase', {params: this.install})
                        .then(() => {
                            this.$Message.success('确认修改安装订单')
                            this.updateTable()
                        }).catch(err => {
                        this.$Message.error('错误' + err)
                        this.updateTable()
                    })
                }
            },
            inputonchange(e){
                console.log(e)
                console.log(this.$refs)
                console.log(this.$refs.uploaderInput.files[0])
                //获取七牛上传凭证
                store.dispatch('PictureServ_GetQiniuUploadToken', {
                    params: {
                        head: 'INSTALLORDER'
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    let uploadToken = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
                    let photoKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
                    let file = this.$refs.uploaderInput.files[0]
                    this.upload(uploadToken, photoKey, file, e)
                }).catch((err) => {
                    console.log(err)
                    this.errorlog('七牛错误' + err)
                })
            },
            upload (uploadToken, photoKey, file, e) {
                console.log('开始上传')
                let that = this
                let param = new FormData() // 创建form对象
                param.append('chunk', '0')// 断点传输
                param.append('chunks', '1')
                param.append('key', photoKey)
                param.append('file', file, file.name)
                param.append('token', uploadToken)

                let config = {
                    headers: { 'Content-Type': 'multipart/form-data' },
                    withCredentials: false
                }

                axios.post('https://upload-z2.qiniup.com', param, config)
                    .then(response => {
                        console.log(response.data)

                        let installOrderPicture = {
                            id: null,
                            picKey: null,
                            picType: null,
                            srcWidth: null,
                            srcHeight: null,
                            upload_token: null,
                            picKey: null,
                        }
                        console.log(that.installOrderId)
                        installOrderPicture.id = that.installOrderId
                        console.log(installOrderPicture.id)
                        installOrderPicture.picType = e.toString()
                        installOrderPicture.srcWidth = null
                        installOrderPicture.srcHeight = null
                        installOrderPicture.upload_token = uploadToken
                        installOrderPicture.picKey = photoKey
                        store.dispatch('InstallOrderServ_UploadInstallorderePicture', {
                            params:
                            installOrderPicture
                            ,
                            urlparams: null
                        }).then(() => {
                            this.$Message.success('添加图片成功')
                            this.$emit('on-success')
                        }).catch(err => {
                            this.$Message.error(err)
                        })
                    }).catch(err1 => {
                    this.$Message.error(err1)
                })
            },

        },
        mounted() {
            // console.log(this.$route.query.installid)
            if (this.$route.query.code != null) {
                this.getCode()
                this.installOrderId = this.$route.query.installid
                this.UploaderInstallOrderVehicleMaterialImageId = this.$route.query.installid
                this.UploaderInstallOrderInstallImageId = this.$route.query.installid
            } else {
                this.installOrderId = this.$route.query.installid
                this.UploaderInstallOrderVehicleMaterialImageId = this.$route.query.installid
                this.UploaderInstallOrderInstallImageId = this.$route.query.installid
            }
            if (this.installOrderId) {
                /**
                 * 查询订单信息
                 */
                store.dispatch('InstallOrderServ_GetPage', {
                    params: null,
                    urlparams: {q: genQueryParam('id', 'EQ', this.installOrderId)}
                }).then((res) => {
                    console.log(res)
                    this.install = res.data.content[0]
                    this.updateTable()
                }).catch((err) => {
                    console.log(err)
                })

            }

        }
    }
</script>

<style scoped>
    .Checkbox {
        padding: 8px;
    }
</style>
